import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-testing',
	templateUrl: './testing.component.html',
	styleUrls: ['./testing.component.scss'],
})
export class TestingComponent implements OnInit {
	protected content = '';
	protected content2 = '';

	constructor() {}

	ngOnInit(): void {
		this.content = '<b>test</b>ccc';
		this.content2 = '';
	}
}
